import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=36967380&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=ts&"
export * from "./Forms.vue?vue&type=script&lang=ts&"
import style0 from "./Forms.vue?vue&type=style&index=0&id=36967380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36967380",
  null
  
)

export default component.exports